import { Product } from "@/models/product.model";
import { axiosInstance } from "./axiosInstance";

export const getProductById = async (id: string): Promise<Product> => {
  try {
    const response = await axiosInstance.get<Product>(`/api/product/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter Produto:", error);
    throw error;
  }
};

export const getAllProducts = async (
  page: number,
  pageSize: number,
  sortBy?: string,
  sortDirection?: string,
): Promise<{ data: Product[]; totalPages: number }> => {
  try {
    const response = await axiosInstance.get<{
      data: Product[];
      page: number;
      pageSize: number;
      totalPages: number;
    }>(`/api/product`, {
      params: {
        page,
        pageSize,
        sortBy,
        sortDirection,
      },
    });

    return {
      data: response.data.data,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};


export const getProductsByCorbanId = async (
  corbanId: string
): Promise<Product[]> => {
  try {
    const response = await axiosInstance.get<Product[]>(
      `/api/product/corban/${corbanId}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter produtos por Corban ID:", error);
    throw error;
  }
};

export const createProduct = async (
  productData: Partial<Product>
): Promise<Product> => {
  try {
    const response = await axiosInstance.post<Product>(
      `/api/product`,
      productData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao criar produto:", error);
    throw error;
  }
};

export const updateProduct = async (
  id: string,
  productData: Partial<Product>
): Promise<Product> => {
  try {
    const response = await axiosInstance.put<Product>(
      `/api/product/${id}`,
      productData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar produto:", error);
    throw error;
  }
};

export const deleteProduct = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/api/product/${id}`);
  } catch (error) {
    console.error("Erro ao deletar produto:", error);
    throw error;
  }
};
